
var pageTraining = {
    filterType = 'all',
    selectedTrainingGoals = [],
    $cardsContainer = jQuery(".training-cards-container"),
    $displayContainer = jQuery(".cards-container"),
    $filterContainer = jQuery('.training-goals-filter-container[data-accordion]'),

    closeAccordion: function() {
        jQuery('.accordion').each(function() {
            var $acc = $(this);
            var $openSections = $acc.find('.accordion-item.is-active .accordion-content');
            $openSections.each(function(i, section) {
                $acc.foundation('up', $(section));
            });
        });
    },

    checkSelectedGoals: function() {
        var spans = document.getElementsByClassName("filter-item-goal-display");
        for (var i = 0; i < spans.length; i++) {
            $class = spans[i].className;
            if (!$class.includes('hide')) {
                $goal = spans[i].getAttribute('data-goal-display');
                if (!pageTraining.selectedTrainingGoals.includes($goal)) {
                    pageTraining.selectedTrainingGoals.push($goal);
                }
            }
        }
    },

    searchCard: function() {
        var self = this;
        this.$displayContainer.empty();
        var $selecteds = [];
        this.$cardsContainer.children().each(function() {
            var isTypeSelected = true;
            var $card = $(this);
            if (self.filterType != 'all') {
                switch (self.filterType) {
                    case 'puppy':
                        isTypeSelected = $.inArray($card.data('type'), ['puppy','puppy-adult']) != -1;
                        break;
                    case 'adult':
                        isTypeSelected = $.inArray($card.data('type'), ['adult','puppy-adult']) != -1;
                        break;
                    default:
                        isTypeSelected = ($card.data('type') == self.filterType);
                }
            }
            var isGoalSelected;
            if (self.selectedTrainingGoals.length > 0) {
                var cardGoals = $card.data('goals').split(',');
                isGoalSelected = false;
                for (var i = 0; i < self.selectedTrainingGoals.length; i++) {
                    if ($.inArray(self.selectedTrainingGoals[i], cardGoals) != -1) {
                        isGoalSelected = true;
                        break;
                    }
                }
            } else {
                isGoalSelected = true;
            }
            if (isTypeSelected && isGoalSelected) {
                $selecteds.push($card);
            }
        });
        jQuery.each($selecteds, function() {
            var $clone = $(this).clone();
            $clone.appendTo(self.$displayContainer);
        });
        Foundation.reInit(this.$displayContainer);
    }
};

(function($) {

    $(".js-trigger-filter-type").on('click', function() {
        pageTraining.filterType = $(this).data('type');
        $('.js-trigger-filter-type').removeClass('filter-selected');
        $(this).addClass('filter-selected');
        pageTraining.closeAccordion();
        pageTraining.searchCard();
    });

    pageTraining.$filterContainer.on('down.zf.accordion', function(event, element) {
        $('.training-goals-selected-item').addClass('hide');
        $('.view-schedule').addClass('hide');
        $(".js-accordion-title-text-medium").addClass('is-active');
    });

    pageTraining.$filterContainer.on('up.zf.accordion', function(event, element) {
        $('.training-goals-selected-item').removeClass('hide');
        $('.view-schedule').removeClass('hide');
        $(".js-accordion-title-text-medium").removeClass('is-active');
    });


    $(".js-accordion-title-text-medium").on('click', function() {
        pageTraining.$filterContainer.foundation('toggle', $('.training-goals-item.accordion-content'));
    });

    $(".js-trigger-filter-goals").on('click', function() {
        pageTraining.checkSelectedGoals();
        var goal = $(this).data('goal');
        $display_filter = $('[data-goal-display=' + goal + ']');

        if (!this.checked) {
            pageTraining.selectedTrainingGoals.splice(pageTraining.selectedTrainingGoals.indexOf(goal), 1);
            $display_filter.addClass('hide');
        } else {
            if (!pageTraining.selectedTrainingGoals.includes(goal)) {
                pageTraining.selectedTrainingGoals.push(goal);
            }
            $display_filter.removeClass('hide');
        }

        pageTraining.searchCard();
    });

    $(".close-training-goals").on('click', function() {
        pageTraining.checkSelectedGoals();
        var goal = $(this).data('goal-hide');
        $('[data-goal=' + goal + ']').prop("checked", false);
        $('[data-goal-display=' + goal + ']').addClass('hide');
        pageTraining.selectedTrainingGoals.splice(pageTraining.selectedTrainingGoals.indexOf(goal), 1);
        pageTraining.searchCard();
    });

    $(window).on("load", function() {
        pageTraining.searchCard();
        // animate scroll if url has hash
        if (window.location.hash) {
            var hash = window.location.hash.substring(1);
            var $target = $(".training-card#" + hash);
            if ($target.length > 0) {
                $target.trigger('click');
            }
        }
    });

    $("#button-explore-all-programs, #button-explore-all-programs-small").on('click', function(e) {
        e.preventDefault();
        var $section = $("#explore-all-programs");
        if ($section.length > 0) {
            $('html,body').animate({ scrollTop: $section.offset().top - 120 }, 'slow');
        }
    });

})(jQuery);